import { Popover } from 'components/common/Popover'
import useTranslation from 'next-translate/useTranslation'
import Image from 'next/image'
import Link from 'next/link'
import { ArtworkRoyalty } from 'types'

type Props = {
  className?: string
  type?: ArtworkRoyalty
}

export const Badge = ({ className, type }: Props) => {
  const { t } = useTranslation()

  const getContent = () => {
    if (type === 'Artist') {
      return (
        <p className='text-sm'>
          🎉 {t('common:we_support')}{' '}
          <Link
            href='/how-it-works/for-artists'
            target='_blank'
            rel='noreferrer'
            className='text-secondary-default'
          >
            {t('common:learn_more')}
          </Link>
        </p>
      )
    }

    if (type === 'Charity') {
      return (
        <p className='text-sm'>
          {t('common:royalties_will_be_donated_to_charity')}
        </p>
      )
    }

    return null
  }

  const imgProps = {
    src:
      type === 'Artist'
        ? '/files/artist-royalties.svg'
        : '/files/charity-royalties-light.svg',
    alt:
      type === 'Artist' ? 'Artist Royalties Badge' : 'Charity Royalties Badge',
    quality: 100,
    width: 80,
    height: 80,
  }

  return (
    <div className={className}>
      <Popover side={'left'} content={getContent()}>
        <div className='relative flex'>
          <Image {...imgProps} alt={imgProps.alt} />
        </div>
      </Popover>
    </div>
  )
}
